import { render, staticRenderFns } from "./ReceivedMessages.vue?vue&type=template&id=05ae9f4e&scoped=true"
import script from "./ReceivedMessages.vue?vue&type=script&lang=js"
export * from "./ReceivedMessages.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/messages.css?vue&type=style&index=0&id=05ae9f4e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ae9f4e",
  null
  
)

export default component.exports